import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';

export const expand = trigger('expandCollapse', [
  state(
    'collapsed',
    style({
      height: '0px',
      overflow: 'hidden',
      padding: 0,
      margin: 0,
      visibility: 'hidden'
    })
  ),
  state(
    'expanded',
    style({
      height: '*',
      visibility: 'visible'
    })
  ),
  transition(
    'collapsed => expanded',
    animate(
      '300ms ease-in',
      style({ padding: '*', margin: '*', height: '*', overflow: 'hidden', visibility: 'visible' })
    )
  ),
  transition(
    'expanded => collapsed',
    animate(
      '300ms ease-out',
      keyframes([
        style({ overflow: 'hidden', offset: 0 }),
        style({ margin: '0', offset: 1 }),
        style({ padding: '0', offset: 1 }),
        style({ height: '0', offset: 1 }),
        style({ visibility: 'hidden', offset: 1 })
      ])
    )
  )
]);
